import clsx from 'clsx';
import { motion, usePresence } from 'motion/react';
import { useEffect } from 'react';
import Modal from '@/components/Modals/Core';
interface InteractiveSidebarContainerProps {
  children: React.ReactNode;
  handleCloseSidebar: (velocity?: number) => void;
}
const SHARED_CLASSNAMES = '@container bg-white dark:bg-gray-900 text-gray-950 dark:text-white sm:max-w-[390px] min-w-60 w-[calc(100%-40px)] h-full fixed top-0 right-0 z-[9999] overflow-x-hidden overflow-y-auto outline-hidden flex flex-col';
const InteractiveSidebarContainer = ({
  handleCloseSidebar,
  children
}: InteractiveSidebarContainerProps) => {
  return <Modal.Content asChild forceMount data-sentry-element="Modal.Content" data-sentry-component="InteractiveSidebarContainer" data-sentry-source-file="SidebarContainer.tsx">
      <motion.div animate={{
      x: 0
    }} className={SHARED_CLASSNAMES} exit={{
      x: '100%'
    }} initial={{
      x: '100%'
    }} key="content"
    // TODO: re-enable when safari error is fixed:
    // drag="x"
    // dragConstraints={{ left: 0 }}
    // dragTransition={{
    //   bounceStiffness: 600,
    //   bounceDamping: 100,
    // }}
    // dragElastic={0}
    // dragSnapToOrigin
    // onDragEnd={(_event, info) => {
    //   // Ignore instance where a user might scroll down at a slight diagonal and accidently close the sidebar
    //   if (info.velocity.y > info.velocity.x || Math.abs(info.delta.y) > 5) {
    //     return;
    //   }

    //   if (info.velocity.x > 200 || info.point.x > 250) {
    //     // Close if dragged significantly to the right
    //     handleCloseSidebar();
    //   }
    // }}
    data-sentry-element="motion.div" data-sentry-source-file="SidebarContainer.tsx">
        {children}
      </motion.div>
    </Modal.Content>;
};
interface NonInteractiveSidebarContainerProps {
  children: React.ReactNode;
}
const NonInteractiveSidebarContainer = ({
  children
}: NonInteractiveSidebarContainerProps) => {
  const [isPresent, safeToRemove] = usePresence();
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    if (!isPresent) {
      timer = setTimeout(safeToRemove, 350);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isPresent, safeToRemove]);
  return <Modal.Content asChild forceMount data-sentry-element="Modal.Content" data-sentry-component="NonInteractiveSidebarContainer" data-sentry-source-file="SidebarContainer.tsx">
      <div className={clsx(SHARED_CLASSNAMES, {
      'animate-slideOutToRight': !isPresent,
      'animate-slideInFromRight': isPresent
    })}>
        {children}
      </div>
    </Modal.Content>;
};
interface SidebarContainerProps extends InteractiveSidebarContainerProps, NonInteractiveSidebarContainerProps {
  interactive?: boolean;
}
const SidebarContainer = ({
  handleCloseSidebar,
  interactive,
  children
}: SidebarContainerProps) => {
  if (interactive) {
    return <InteractiveSidebarContainer handleCloseSidebar={handleCloseSidebar}>
        {children}
      </InteractiveSidebarContainer>;
  }
  return <NonInteractiveSidebarContainer data-sentry-element="NonInteractiveSidebarContainer" data-sentry-component="SidebarContainer" data-sentry-source-file="SidebarContainer.tsx">{children}</NonInteractiveSidebarContainer>;
};
export default SidebarContainer;